import { createSlice } from '@reduxjs/toolkit'
import { logOut } from '../authentication/authenticationSlice';
import { markCaseWithoutPlate } from '../cases/thunks';
import { blockCase, setDocumentation, setWorkshopAppointment, unBlockCase, updateClickToCall, sendFactoryComment, advanceFactoryCase, setTerminations, setSubstitutionVehicle, setClaims, setDelivery, setFuelCard, setOvc, setItv, setMarsh, setLetter, setLetterQuery } from './thunks';
import { regressFactoryCase } from '../caseForms/thunks';
import { getContract, getContractByCaseId,getCommentByCaseId, updateCase,createCase, newCase, associateContract, attachIdtProcessToCase } from "../contract/thunks"

const initialState = {
  currentCase: {
    case: null,
    casePreviousState: {firstState:null,stateChanged:null}
  },
  loading: "idle",
  error: null
}


const currentCaseSlice = createSlice({
  name: 'currentCase',
  initialState,
  reducers: {
    clearCurrentCase: (state)=>{
      state.currentCase.case = null
    },
    updateCaseForm: (state,action)=>{
      state.currentCase.case = {...state.currentCase.case, ...action.payload}
    },
    setPreviousCaseState:(state,action)=>{
      if(action.payload.changed)
        state.currentCase.casePreviousState.stateChanged = action.payload.value
        else 
          state.currentCase.casePreviousState.firstState = action.payload.value
    },
  },
  extraReducers: {
    [getContract.pending]: (state) => {
      state.loading= "loading";
      state.error = null
    },
    [getContract.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.currentCase.case = action.payload.case;
      state.currentCase.casePreviousState ={firstState:action.payload?.case?.caseId,stateChanged:null}
    },
    [getContract.rejected]:(state, action) =>
    {state.currentCase = initialState.currentCase;
    state.loading = "failed";
    state.error = action.error.message
    },
    [getContractByCaseId.pending]: (state) => {
      state.loading = "loading";
      state.error = null
    },
    [getContractByCaseId.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.currentCase.case = action.payload.case;
      state.currentCase.casePreviousState ={firstState:action.payload?.case?.caseId,stateChanged:null}
    },
    [getContractByCaseId.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [updateCase.pending]: (state) => {
      state.loading = "updating";
      state.error = null
    },
    [updateCase.fulfilled]: (state,action) => {
      state.loading = "succeeded";
      state.currentCase.case = action.payload
      delete state.currentCase.historic
    },
    [updateCase.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [createCase.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [createCase.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.currentCase.case = action.payload
    },
    [createCase.rejected]: (state,action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [newCase.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [newCase.fulfilled]: (state,action) => {
      state.loading = "succeeded";
      state.currentCase.case = action.payload
    },
    [newCase.rejected]: (state,action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [getCommentByCaseId.pending]: (state) => {
      state.loading = "updating";
      state.error = null;
    },
    [getCommentByCaseId.fulfilled]: (state,action) => {
      state.loading = "succeeded";
      state.currentCase.case.comments = action.payload;
    },
    [getCommentByCaseId.rejected]: (state,action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [blockCase.pending]: (state) =>{
      state.loading = "updating";
      state.error = null
    },
    [blockCase.fulfilled]: (state, action) =>{
      state.loading = "succeeded";
      state.currentCase.case = {
                                  ...state.currentCase.case, blockedByUser: action.payload.blockedByUser,
                                  blockedByUserId: action.payload.blockedByUserId,
                                  user: action.payload.user
                                }
      state.error = null
    },
    [blockCase.rejected]: (state) =>{
      state.loading = "failed";
      state.error = null
    },
    [unBlockCase.pending]: (state) =>{
      state.loading = "updating";
      state.error = null
    },
    [unBlockCase.fulfilled]: (state, action) =>{
      state.loading = "succeeded";
      state.currentCase.case = {...state.currentCase.case, blockedByUser: action.payload.blockedByUser, blockedByUserId: action.payload.blockedByUserId}
      state.error = null
    },
    [unBlockCase.pending]: (state) =>{
      state.loading = "failed";
      state.error = null
    },
    [associateContract.fulfilled]: (state, action) => {
      state.currentCase.case.comments = action.payload.case.comments;
      state.currentCase.case.withoutPlate = false
    },
    [markCaseWithoutPlate.pending]: (state) => {
      state.loading = "updating";
      state.error = null
    },
    [markCaseWithoutPlate.fulfilled]: (state,action) => {
      state.loading = "succeeded";
      state.currentCase.case.withoutPlate = action.payload.withoutPlate
      state.currentCase.case.comments = action.payload.comments
      delete state.currentCase.historic
    },
    [markCaseWithoutPlate.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [updateClickToCall.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null
    },
    [updateClickToCall.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.currentCase.case.phoneNumber = action.payload.phoneNumber;
      state.currentCase.case.comments = action.payload.comments
      state.error = null
    },
    [updateClickToCall.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [setWorkshopAppointment.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null
    },
    [setWorkshopAppointment.fulfilled]: (state, action)=>{
      state.loading = "succeeded";
      var comment = state.currentCase.case.currentComment;
      state.currentCase.case = action.payload;
      state.currentCase.case.currentComment =comment
    },
    [setDocumentation.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null
    },
    [setDocumentation.fulfilled]: (state, action)=>{
      state.loading = "succeeded";
      var comment = state.currentCase.case.currentComment;
      state.currentCase.case = action.payload;
      state.currentCase.case.currentComment =comment
    },
    [setTerminations.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null
    },
    [setTerminations.fulfilled]: (state, action)=>{
      state.loading = "succeeded";
      var comment = state.currentCase.case.currentComment;
      state.currentCase.case = action.payload;
      state.currentCase.case.currentComment =comment
    },
    [setSubstitutionVehicle.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null
    },
    [setSubstitutionVehicle.fulfilled]: (state, action)=>{
      state.loading = "succeeded";
      var comment = state.currentCase.case.currentComment; 
      state.currentCase.case = action.payload;
      state.currentCase.case.currentComment =comment
    },
    [setClaims.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setClaims.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setClaims.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [setDelivery.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setDelivery.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setDelivery.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [setOvc.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setOvc.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setOvc.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [setItv.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setItv.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setItv.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [setFuelCard.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setFuelCard.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setFuelCard.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [setMarsh.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setMarsh.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setMarsh.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [setLetter.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setLetter.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setLetterQuery.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [setLetterQuery.pending]: (state, action) => {
      state.loading = "updating";
      state.error = null;
    },
    [setLetterQuery.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      let comment = state.currentCase.case.currentComment;
      state.currentCase.case = {...action.payload, currentComment: state.currentCase.case.currentComment}
      state.currentCase.case.currentComment = comment
    },
    [setLetter.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    // [sendFactoryComment.pending]:(state)=>{
    //   state.loading = "updating";
    //   state.error = null;
    // },
    // [sendFactoryComment.fulfilled]:(state, action)=>{
    //   state.loading = "succeeded";
    //   state.error = null;
    //   var comment = state.currentCase.case.currentComment;
    //   state.currentCase.case.comments.unshift(action.payload)
    //   state.currentCase.case.currentComment =comment;
    // },
    [advanceFactoryCase.rejected]:(state)=>{
      state.loading = "failed";
      state.error = null;
    },
    [advanceFactoryCase.fulfilled]:(state, action)=>{
      state.loading = "succeeded";
      state.error = null;
      var comment = state.currentCase.case.currentComment;
      state.currentCase.case.comments.unshift(action.payload)
      state.currentCase.case.currentComment =comment;
      state.currentCase.case.factoryInteractionAllowed = false;
    },
    [advanceFactoryCase.rejected]:(state)=>{
      state.loading = "failed";
      state.error = null;
      },
    [attachIdtProcessToCase.pending]: (state)=>{
      state.loading = "updating";
      state.error = null
    },
    [attachIdtProcessToCase.fulfilled]: (state, action)=>{
      state.loading = "succeeded";
      state.currentCase.case.idtProcessId = action.payload.idtProcessId;
      state.error = null
    },
    [attachIdtProcessToCase.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [regressFactoryCase.fulfilled]:(state, action)=>{
      state.loading = "succeeded";
      state.currentCase.case.factoryInteractionAllowed = false;
      state.currentCase.case.state = action.payload.state;
      state.currentCase.case.stateId = action.payload.stateId;
      state.error = null;
    },
    [regressFactoryCase.rejected]:(state)=>{
      state.loading = "failed";
      state.error = null;
    },
    [logOut]: (state)=> initialState
  }
})

export const { clearCurrentCase, updateCaseForm , setPreviousCaseState, setFormAppointmentProperty,
               setFormAppointment, setFormDocumentationProperty, setFormDocumentation, setFormClaimsProperty,
                setFormClaims, setFormInformation, setFormInformationProperty,setFormTerminations,setFormTerminationsProperty,
                setFormSubstitutionVehicle,setFormSubstitutionVehicleProperty, setFormDeliveryProperty,
                setFormDelivery, setFormOtherProperty, setFormOther} = currentCaseSlice.actions;

export default currentCaseSlice.reducer
